import { fetchApi } from 'shared/functions';
import { jobFunctionsParser } from 'shared/parsers';

export const fetchJobFunctions = () => {
  return fetchApi(`/sso/config/jobfunctions`)
    .then(res => res.json())
    .then(res => res && jobFunctionsParser(res.data));
};
